import { AfterContentInit, Directive, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[afterContentInit]',
  exportAs: 'afterContentInit'
})
export class AfterContentInitDirective implements AfterContentInit {
  @Input() afterContentInit: Function;

  public ngAfterContentInit() {
    if (this.afterContentInit && typeof this.afterContentInit === 'function') {
      this.afterContentInit();
    }
  }
}
